module.exports = global["jQuery"] = require("-!/Users/jason/devsites/predictivemedianet-com/wp-content/themes/wlion/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 10
// module chunks = 1 2